// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"480":"a83e49a8","487":"9a44fad5","751":"157ae3c2"}[chunkId] + ".css";
};